import { writable } from 'svelte/store';
export const logList = writable([]);
export const hrmsData = writable([]);
export const lastSeenLog = writable(null);

